import { render } from "./rdetail.vue?vue&type=template&id=713efe4c"
import script from "./rdetail.vue?vue&type=script&lang=js"
export * from "./rdetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__